<template>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline">
          Dodaj wymiar
        </v-card-title>
        <v-card-text>
          <v-form
              ref="newForm"
              v-model="valid"
              lazy-validation
              class="dimension--form mt-5 mb-5"
          >
            <v-row>
              <v-col cols="12" md="12" align-self="start" dense>
                <v-text-field
                    ref="name"
                    v-model="form.name"
                    label="Nazwa"
                    solo
                    class="wastemaster-input-elevation"
                    autofocus
                ></v-text-field>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  @click.prevent="onSubmit"
                  type="Submit"
                  class="action-btn--green-gradient place-btn wastemaster-action-btn text-none"
                  large
              >Dodaj&nbsp;<v-icon size="24">mdi-send</v-icon></v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>

import api from "@/services/api";
import transactionTypeMixin from "@/mixins/transactionTypeMixin";
import transportConditionMixin from "@/mixins/transportConditionMixin";
import categoryMixin from "@/mixins/categoryMixin";
import priceMixin from "@/mixins/priceMixin";
import paymentConditionMixin from "@/mixins/paymentConditionMixin";
import dateMixin from "@/mixins/dateMixin";
import validationHelpers from '@/mixins/validationHelpers'

export default {
  name: 'ModalAddDimension',
  components: {  },
  props: {
    item: {},
  },
  mixins: [
      transactionTypeMixin,
      transportConditionMixin,
      categoryMixin,
      priceMixin,
      paymentConditionMixin,
      dateMixin,
      validationHelpers
  ],
  created() {
  },
  data: () => ({
    partners: [],
    unit: "",
    dialog: false,
    maxPrice: 999999999,
    validUntilMenu: false,
    form: {
      name: '',
    },
    formRules: {
      name: [(value) => value.length === 0 || 'Wpisz nazwę'],
    },
    valid: false,
  }),
  methods: {
    open() {
      this.dialog = true
    },
    async onSubmit() {
      if (!this.$refs.newForm.validate()) {
        return
      }

      const dimension = {
        name: this.form.name,
      }
      api
          .post('/api/categories/' + this.item + '/dimension' ,dimension)
          .then(() => {
            this.$root.$emit('notifySuccess', {
              html: 'Wymiar został dodany.',
            });
            this.dialog = false;
            this.form.name = '';
            this.$parent.loadDetails();
          })
          .catch((error) => {
            console.error('Error when adding a dimension:', error);
            this.$root.$emit('notifyError', {
              html: 'Wystąpił błąd.',
            });
          })
    },
  },
}
</script>

<style scoped></style>
